<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{ $t("lbl.pelletizing.qualityResult.selfTestPelletizingGriList") }}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/prd">
              <span>{{$t('tlt.pelletizing')}}</span>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/prd/selfTestPelletizing">
              <span>{{$t('tlt.pelletizing.selfTestPelletizing')}}</span>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/prd/selfTestPelletizing/edit">
              <span>{{$t('tlt.pelletizing.selfTestPelletizing.new')}}</span>
            </router-link>
          </li>
        </ul>
      </div>

      <div class="col-lg-4">
        <div class="float-lg-right">
          <button
            class="btn btn-outline-secondary mr-1"
            type="button"
            v-on:click="MMFbackToList('selfTestPelletizing')"
          >
            <i class="fa fa-fw fa-lg fa-minus-circle"></i>
            <span class="text">{{$t('btn.basic.cancel')}}</span>
          </button>
          <button class="btn btn-primary" type="button" v-on:click="MMFSave('selfTestPelletizing')">
            <i class="fa fa-fw fa-lg fa-save"></i>
            <span class="text">{{$t('btn.basic.save')}}</span>
          </button>
        </div>
      </div>
    </div>
    <section class="app-content">
      <form>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.selfTestPelletizing.testCode')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="testCode"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('testCode') }"
                  v-model="testCode"
                  type="text"
                />
                <span v-show="errors.has('testCode')" class="lbl-obg">{{ errors.first('testCode') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.selfTestPelletizing.testTime')}}：
                </label>
                <mmf-datepicker v-model="testTime"></mmf-datepicker>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.selfTestPelletizing.testPlant')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="testPlant"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('testPlant') }"
                  v-model="testPlant"
                  type="text"
                />
                <span
                  v-show="errors.has('testPlant')"
                  class="lbl-obg"
                >{{ errors.first('testPlant') }}</span>
              </div>
              <div class="form-group col-md-2">
                <label class="control-label">
                  <span class="lbl-obg">*</span>
                  {{$t('lbl.selfTestPelletizing.testShift')}}:
                </label>
                <input
                  v-validate="'required'"
                  name="testShift"
                  :class="{'form-control form-control-sm': true, 'is-invalid': errors.has('testShift') }"
                  v-model="testShift"
                  type="text"
                />
                <span
                  v-show="errors.has('testShift')"
                  class="lbl-obg"
                >{{ errors.first('testShift') }}</span>
              </div>
            </div>
          </div>
        </div>
      </form>
    </section>
  </div>
</template>
<style>
.CodeMirror {
  border: 1px solid #eee;
  /* todo change to responsible */
  height: 260px;
}
</style>
<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import { fields } from "@/model/prd/qualityMgt/selfTest/SelfTestPelletizing";
import MmfDatepicker from "@/components/MmfDatepicker";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
  getterType: "selfTestPelletizing/getField",
  mutationType: "selfTestPelletizing/updateField"
});

export default {
  name: "selfTestPelletizingEdit",
  data() {
    return {};
  },

  computed: {
    // generate and add getters and setters using the filter names defined in
    // entity model

    ...mapFields(fields),
    ...mapState({
      rows: state => state.selfTestPelletizing.rows,

      entity: state => state.selfTestPelletizing.entity
    })
  },
  methods: {
    ...mapActions("base", ["MMFbackToList", "MMFSave"])
  },
  components: {
    MmfDatepicker
  }
};
</script>
